import {
    slideUp,
    slideDown,
    fadeIn,
} from '@js/common/all-functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const mapSections = document.querySelectorAll('.map-component-section');

    mapSections.forEach(section => {
        // Changed selector: only target .h5 inside .mcs-country-item
        const allHeadingItems = section.querySelectorAll('.mcs-country-item .h5');

        // Update dropdown title for initially active item
        const allCountryItems = section.querySelectorAll('.mcs-dropdown .mcs-country-item');
        allCountryItems.forEach(item => {
            if (item.classList.contains('is-active')) {
                const heading = item.querySelector('.mcs-country-heading');
                const dropdownTitle = section.querySelector('.dropdown-title');

                if (heading && dropdownTitle) {
                    dropdownTitle.innerHTML = heading.innerHTML;
                }
            }
        });

        allHeadingItems.forEach(heading => {
            heading.addEventListener('click', (e) => {
                e.preventDefault();

                const item = heading.closest('.mcs-country-item');
                if (!item) {return;}

                const targetId = item.getAttribute('data-href');
                if (!targetId) {return;}

                const isActive = item.classList.contains('is-active');

                if (isActive) {
                    // If already active, deactivate and hide list
                    item.classList.remove('is-active');

                    const nameList = item.querySelector('.mcs-country-name-list');
                    if (nameList) {
                        slideUp(nameList);
                    }

                    const sidebar = item.querySelector('.mcs-country-name-sidebar');
                    if (sidebar) {
                        sidebar.style.display = 'none';
                    }

                    // Optionally: hide map section if needed
                    const mcsWrap = section.querySelector('.mcs-wrap');
                    if (mcsWrap) {
                        const allTargets = mcsWrap.querySelectorAll(`[data-id="${targetId}"]`);
                        allTargets.forEach(el => {
                            el.style.display = 'none';
                        });

                        // ✅ Check if no other .mcs-country-item is active
                        const anyActive = Array.from(item).some(el => el.classList.contains('is-active'));

                        if (!anyActive) {
                            // ✅ Show the first .mcs-map-item
                            const firstMapItem = mcsWrap.querySelector('.mcs-map-item');
                            if (firstMapItem) {
                                fadeIn(firstMapItem);
                            }
                        }
                    }

                    return; // Exit early
                }

                // If not active, proceed with normal activation
                const allItems = section.querySelectorAll('.mcs-country-item');
                allItems.forEach(otherItem => {
                    otherItem.classList.remove('is-active');

                    const nameList = otherItem.querySelector('.mcs-country-name-list');
                    if (nameList) {
                        slideUp(nameList);
                    }

                    const sidebar = otherItem.querySelector('.mcs-country-name-sidebar');
                    if (sidebar) {
                        sidebar.style.display = 'none';
                    }
                });

                // Show only relevant map items
                const mcsWrap = section.querySelector('.mcs-wrap');
                if (mcsWrap) {
                    const allTargets = mcsWrap.querySelectorAll('[data-id]');
                    allTargets.forEach(el => {
                        el.style.display = 'none';
                    });

                    const targetEls = mcsWrap.querySelectorAll(`[data-id="${targetId}"]`);
                    targetEls.forEach(el => {
                        fadeIn(el);
                    });
                }

                setTimeout(() => {
                    item.classList.add('is-active');

                    const sidebar = item.querySelector('.mcs-country-name-sidebar');
                    if (sidebar) {
                        fadeIn(sidebar);
                    }

                    const nameList = item.querySelector('.mcs-country-name-list');
                    if (nameList) {
                        slideDown(nameList);
                    }

                    const dropdownTitle = section.querySelector('.dropdown-title');
                    if (dropdownTitle) {
                        const headingContent = item.querySelector('.mcs-country-heading');
                        if (headingContent) {
                            dropdownTitle.innerHTML = headingContent.innerHTML;
                        }
                    }
                }, 550);
            });
        });

        // Dropdown toggle
        const dropdownTitles = section.querySelectorAll('.dropdown-title');
        dropdownTitles.forEach(title => {
            title.addEventListener('click', () => {
                const isActive = title.classList.contains('is-active');
                const countryList = title.nextElementSibling;

                title.classList.toggle('is-active');

                if (countryList && countryList.classList.contains('mcs-country-list')) {
                    if (!isActive) {
                        slideDown(countryList);
                    } else {
                        slideUp(countryList);
                    }
                }
            });
        });

        // Close dropdown on mobile item click
        const mobileCountryItems = section.querySelectorAll('.mcs-dropdown .mcs-country-item');
        mobileCountryItems.forEach(item => {
            item.addEventListener('click', () => {
                const dropdown = item.closest('.mcs-dropdown');
                const title = dropdown ?.querySelector('.dropdown-title');
                const countryList = dropdown ?.querySelector('.mcs-country-list');

                if (title) {
                    title.classList.remove('is-active');
                }
                if (countryList) {
                    slideUp(countryList);
                }
            });
        });

        // Sidebar hover logic
        const sidebarItems = section.querySelectorAll('.mcs-country-name-sidebar .sidebar-item');
        sidebarItems.forEach(sidebarItem => {
            sidebarItem.addEventListener('mouseenter', () => {
                const targetId = sidebarItem.getAttribute('data-href');
                if (!targetId) {
                    return;
                }

                const mcsWrap = section.querySelector('.mcs-wrap');
                if (!mcsWrap) {
                    return;
                }

                const allTargets = mcsWrap.querySelectorAll('.mcs-map-item[data-id]');
                allTargets.forEach(el => el.style.display = 'none');

                const targetEls = mcsWrap.querySelectorAll(`.mcs-map-item[data-id="${targetId}"]`);
                targetEls.forEach(el => fadeIn(el));
            });

            sidebarItem.addEventListener('mouseleave', () => {
                const activeItem = section.querySelector('.mcs-country-item.is-active');
                if (!activeItem) {
                    return;
                }

                const activeId = activeItem.getAttribute('data-href');
                if (!activeId) {
                    return;
                }

                const mcsWrap = section.querySelector('.mcs-wrap');
                if (!mcsWrap) {
                    return;
                }

                const allTargets = mcsWrap.querySelectorAll('.mcs-map-item[data-id]');
                allTargets.forEach(el => el.style.display = 'none');

                const targetEls = mcsWrap.querySelectorAll(`.mcs-map-item[data-id="${activeId}"]`);
                targetEls.forEach(el => fadeIn(el));
            });
        });
    });
});
